// extracted by mini-css-extract-plugin
module.exports = {"legendPositionRoot":"hFvfLu6w"};